import { ThemePalette } from '../schema/MiniPalette';

export const BASE_LIGHT_THEME_PALETTE: ThemePalette = {
    themeDarker: '#004578',
    themeDarkerAlt: '#194273',
    themeDark: '#005A9E',
    themeDarkAlt: '#106EBE',
    themePrimary: '#0078d4',
    themeSecondary: '#2B88D8',
    themeTertiary: '#71AFE5',
    themeLight: '#C7E0F4',
    themeLighter: '#DEECF9',
    themeLighterAlt: '#EFF6FC',

    // Common
    sidePaneSelectedBackground: '#bad7ed',
    headerBackground: '#0078d4',
    headerButtonBackground: '#106EBE',
    headerButtonPressedBackground: '#0060AA',
    headerSearchBarBackground: '#0060AA',
    headerSearchBarButtonPressedBackground: '#004578',

    // Mail
    activePillBg: '#0078d4',
    activePillFg: '#f8f8f8',
    inactivePillBg: '#f1f1f1',
    inactivePillFg: '#6e6e6e',
    activePillBgOnThemeBg: '#ffffff',
    activePillFgOnThemeBg: '#0078d4',
    inactivePillBgOnThemeBg: '#106ebe',
    inactivePillFgOnThemeBg: '#ffffff',
};
